import React, { useContext } from 'react';
import { LanguageContext } from '../../../context/LanguageContext';
import webDashboardTranslations from '../../../languages/webDashboard.json';

const pinCategories = ['Virtual Pin', 'Enum', 'Location', 'Digital Pin', 'Analog Pin'];

const CreateDatastream = ({ onSelect }) => {
  const { lang } = useContext(LanguageContext);
  const t = webDashboardTranslations[lang]?.createDatastream || {};

  return (
    <div className="form-item">
      <p>{t.noDatastreams || 'No datastreams found.'}</p>
      <div style={{ position: 'relative' }}>
        <button
          className="add-btn"
          onClick={() => {
            const menu = document.querySelector('.categories');
            const display = document.defaultView.getComputedStyle(menu).display;
            menu.style.display = display === 'block' ? 'none' : 'block';
          }}
        >
          <span>+</span>
          <span>{t.newDatastreams || 'New Datastream'}</span>
        </button>
        <ul className="details-actions-menu categories" style={{ zIndex: 3 }}>
          {pinCategories.map((cat, index) => (
            <li
              key={index}
              onClick={() => {
                const menu = document.querySelector('.categories');
                menu.style.display = 'none';
                onSelect(cat);
              }}
              className="details-actions-menu-item categories-item"
            >
              {cat}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CreateDatastream;
